import React from 'react';
import Tool01Panel from './Tool01Panel';
import Tool02Panel from './Tool02Panel';
import Tool03Panel from './Tool03Panel';
import Tool04Panel from './Tool04Panel';  // 引入 Tool04Panel

const ToolPanel = ({ selectedTool, toolProps, onUpdate, clearPaths, downloadSVGTool01, downloadSVGTool02, downloadSVGTool04 }) => {
  const renderToolPanel = () => {
    switch (selectedTool) {
      case 'tool01':
        return (
          <Tool01Panel
            toolProps={toolProps}
            onUpdate={onUpdate}
            downloadSVG={downloadSVGTool01}  // Download SVG for Tool01
          />
        );
      case 'tool02':
        return (
          <Tool02Panel
            toolProps={toolProps}
            onUpdate={onUpdate}
            clearPaths={clearPaths}   // Clear paths for Tool02
            downloadSVG={downloadSVGTool02}  // Download SVG for Tool02
          />
        );
      case 'tool03':
        return (
          <Tool03Panel
            toolProps={toolProps}
            onUpdate={onUpdate}
          />
        );
      case 'tool04':  // 处理 Tool04 的逻辑
        return (
          <Tool04Panel
            toolProps={toolProps}
            onUpdate={onUpdate}
            downloadSVG={downloadSVGTool04}  // Download SVG for Tool04
          />
        );
      default:
        return null;
    }
  };

  return <div className="tool-panel">{renderToolPanel()}</div>;
};

export default ToolPanel;
